class LoginForm extends HTMLElement {
  constructor() {
    super();

    const form = this.querySelector("#customer_login");
    this.submitButton = form.querySelector("button");
    this.email_field = this.querySelector("#CustomerEmail");
    this.email_error_field = this.querySelector("#CustomerEmailError");
    this.password_field = this.querySelector("#CustomerPassword");
    this.password_error_field = this.querySelector("#CustomerPasswordError");
    this.submission_error_field = this.querySelector("#CustomerSubmissionError");
    this.store_fron_url = 'https://craftgin.myshopify.com/api/2026-10/graphql.json';

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitForm(event, form);
    });

    this.email_field.addEventListener('keydown', () => 
      this.hideError(this.email_error_field)
    );
    this.password_field.addEventListener('keydown', () => 
      this.hideError(this.password_error_field)
    );
  }

  async submitForm(event, form) {
    try {
      this.hideError(this.submission_error_field);
      if (!this.validFields()) return;

      this.setLoading(true);
      const formData = new FormData(event.target);
      formData.delete('checkout_url');

      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
      });

      this.setLoading(false);
      if (response.ok) {
        const {success, message} = await this.getCustomerAccessToken();

        if (!success) {
          this.displayError(this.submission_error_field, message);
          return;
        }

        this.redirectCustomer();
      }
      else {
        this.displayError("Error with logging in." + response.statusText);
        console.error("Form submission failed: ", response.statusText);
      }
    }
    catch(error) {
      this.setLoading(false);
      console.error("Error in submitting form: ", error);
    }
  }

  validFields() {
    const emailStatus = this.validateEmail(this.email_field.value);
    if (!emailStatus.valid) {
      this.displayError(this.email_error_field, emailStatus.message);
    }

    const passwordStatus = this.validatePassword(this.password_field.value);
    if (!passwordStatus.valid) {
      this.displayError(this.password_error_field, passwordStatus.message);
    }

    const fieldsAreValid = emailStatus.valid && passwordStatus.valid;
    return fieldsAreValid;
  }

  validateEmail(email) {
    if (!email) {
      return({ valid: false, message: "No email provided" });
    }

    const EMAIL_REGEX = /^[^\s@,;:]+@[^\s@]+\.[^\s@]+$/;
    const errorMessage = "Email must contain username, @, and domain name eg. 'test@gmail.com'";

    if (!EMAIL_REGEX.test(email)) {
      return ({ valid: false, message: errorMessage });
    }

    return ({ valid: true });
  }

  validatePassword(password) {
    if (!password) {
      return({ valid: false, message: "No password provided" });
    }

    return ({ valid: true });
  }

  displayError(field, message) {
    field.innerHTML = message;
    field.style.display = 'block';
  }

  hideError(field) {
    field.innerHTML = '';
    field.style.display = 'none';
  }

  setLoading(loading) {
    const loadingSpinner = this.submitButton.querySelector('.loading__spinner');

    if (loading) {
      this.submitButton.setAttribute('disabled', '');
      this.submitButton.style.color = "transparent";
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
        loadingSpinner.querySelector('.path').style.stroke = "white";
      };
      return;
    }

    this.submitButton.removeAttribute("disabled");
    this.submitButton.style.color = "white";
    if (loadingSpinner) {
      loadingSpinner.classList.add("hidden");
      loadingSpinner.querySelector('.path').style.stroke = "none";
    };
  }

  async getCustomerAccessToken() {
    const email = this.email_field.value;
    const password = this.password_field.value;

    const query = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;

    const variables = { input: { email, password } };

    const config = fetchConfig('javascript');
    const SHOPIFY_STOREFRONT_TOKEN = 'd0c759630bac3d3ae47cb98c66616ca1';
    config.headers['X-Shopify-Storefront-Access-Token'] = SHOPIFY_STOREFRONT_TOKEN;
    config.body = JSON.stringify({ query, variables });
    config.method = "POST";

    const response = await fetch(this.store_fron_url, config);
    const result = await response.json();
    const payload = result.data?.customerAccessTokenCreate;

    if (!payload || payload.customerUserErrors.length) {
      const error = payload.customerUserErrors[0];
      return {
        success: false,
        message: "Invalid email or password"
      };
    }

    return {
      success: true,
      message: null
    }
  }

  redirectCustomer() {
    const searchParams = new URLSearchParams(window.location.search);
    const callbackUrl = searchParams.get('return') || searchParams.get('checkout_url');

    if (callbackUrl) {
      window.location.assign(callbackUrl);
    }
    else {
      window.location.assign('/account');
    }
  }
}

if (!customElements.get('login-form')) {
  window.customElements.define('login-form', LoginForm);
}
